import { useEffect } from 'preact/hooks';
import { signal } from '@preact/signals';
import { api } from '../../api/client';
import { AnomalyCard } from '../../components/intelligence/AnomalyCard';
import { FilterBar, createFilterState, filtersToParams } from '../../components/intelligence/FilterBar';
import { SkeletonCard } from '../../components/intelligence/SkeletonLoader';
import { Button } from '../../components/ui';

interface Anomaly {
  id: string;
  metric: string;
  severity: 'S1' | 'S2' | 'S3' | 'S4';
  description: string;
  detected_at: string;
  possible_causes: string[];
  status: string;
}

const loading = signal(true);
const error = signal('');
const anomalies = signal<Anomaly[]>([]);
const filters = createFilterState();
const filterSeverity = signal<string>('');

async function loadData() {
  loading.value = true;
  error.value = '';
  try {
    const params = filtersToParams(filters.value);
    const res = await api.get<{ anomalies: Anomaly[] }>(`/intelligence/anomalies?${params.toString()}`);
    anomalies.value = res.anomalies || [];
  } catch (err: any) {
    error.value = err.message || 'Erro ao carregar anomalias';
    anomalies.value = [];
  } finally {
    loading.value = false;
  }
}

function handleCreateIncident(id: string) {
  alert(`Incidente criado para anomalia ${id}`);
}

export function AnomaliesPanel() {
  useEffect(() => { loadData(); }, []);

  const filtered = filterSeverity.value
    ? anomalies.value.filter((a) => a.severity === filterSeverity.value)
    : anomalies.value;

  return (
    <div>
 <h2 class="text-xl font-bold text-white mb-4">Anomalias</h2>
      <FilterBar filters={filters} onApply={loadData} />

      <div class="flex gap-2 mb-4">
        {['', 'S1', 'S2', 'S3', 'S4'].map((v) => (
          <Button variant="ghost"
            key={v}
            class={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
              filterSeverity.value === v ? 'bg-indigo-600 text-white' : 'bg-gray-800 text-gray-400 hover:text-gray-200'
            }`}
            onClick={() => { filterSeverity.value = v; }}
          >
            {v || 'Todas'}
          </Button>
        ))}
      </div>

      {error.value && (
        <div class="bg-red-500/10 border border-red-500/30 text-red-400 rounded-lg p-3 mb-4 text-sm">{error.value}</div>
      )}

      {/* Timeline view */}
      <div class="space-y-4">
        {loading.value ? (
          Array.from({ length: 4 }).map((_, i) => <SkeletonCard key={i} lines={4} />)
        ) : filtered.length === 0 ? (
 <div class="text-gray-500 text-center py-12">Nenhuma anomalia detectada</div>
        ) : (
          filtered.map((a) => (
            <AnomalyCard
              key={a.id}
              id={a.id}
              metric={a.metric}
              severity={a.severity}
              description={a.description}
              detected_at={a.detected_at}
              possible_causes={a.possible_causes}
              onCreateIncident={handleCreateIncident}
            />
          ))
        )}
      </div>
    </div>
  );
}
